<script setup>
import AppBar from '@/layouts/layout-components/AppBar.vue';
</script>

<template>
  <div>
    <app-bar class="bg-primary" />
    <v-main>
      <v-container class="py-8 px-6" fluid>
        <router-view />
      </v-container>
    </v-main>
  </div>
</template>

<style scoped>

</style>
